module.exports = __webpack_public_path__ + "static/media/AS.e46b65c0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/country-flags/AS.svg
// module id = 2101
// module chunks = 7